<template>
  <div  id="Market" :data-theme="theme" class="Market">
    <!-- 公共头 -->
    <MarketHeader />
    <div class="market_marketContent">
      <div class="market_leftbar">
        <TokenList key=""/>
      </div>
      <div class="market_middlebar">
        <!-- 交易对 -->
        <TokenInfo  />
        <div class="market_chartWrapper" >
          

        <!-- <tradingview/> -->
      <ChartContainer></ChartContainer>

        </div>
      </div>
      <div class="market_rightbar">
        <!-- 盘口 -->
        <Handicap /> 

      </div>

    </div>
  </div>
</template>


<script>

// import {setToken,getToken} from '../utils/auth'
// import {USER_Market} from '../api/user'
import  MarketHeader  from "@/components/MarketHeader/index.vue";
import  TokenList  from "@/components/TokenList/index.vue";
import  TokenInfo  from "@/components/TokenInfo/index.vue";
 import ChartContainer from "@/tradingview/ChartContainer.vue";
import  Handicap  from "@/components/Handicap/index.vue";
import {mapActions ,mapGetters,mapState } from "vuex";
import {recentTrade,exInfo,bitCode,bitLogin,bitScore,tickerDay,deteIp} from '@/api/wiki'
import socket from "../tradingview/api/socket";
// import {  } from "@/utils/baseFn/filter";

export default {
  name: 'Market',
  components: {
    MarketHeader,
    TokenList,
    TokenInfo,
    ChartContainer,
    Handicap
  },
  data() {
    return {
      socket:null,
      urls : '',
      lockReconnect:false,
      lang:'',
      value:{},
      isShow:false,
      checked:true,
      symbol:'on',
      currency_id:0,
      marketId: this.$route.query.marketId,
      marketName: this.$route.query.marketName,
      decimal: 100,
      tokencode:'',
      
      quoteAsset:'',
    
    }
  },
  computed: {
    ...mapState(['symbolList','wsTickerList','trade','theme','baseAsset','country']),
    ...mapGetters(['getTokenCode','getSymbolTicker','getBaseAssetByTokenCode']),

  },
  created() {
    let time= localStorage.getItem('WikiBit_Time')
    if(!time){
      localStorage.removeItem('tradingview.chartproperties')
      localStorage.setItem('WikiBit_Time', new Date())
    }

  },
  mounted() {
  // let url='http://192.168.1.84:8066/zh/market/USDT/6392453855120.html'
    let local= location.href.split('/')[3]
    if(local!=='zh'&&local!=='zh-cn'&&local!=='en'&&local!=='ja'&&local!=='vi'&&local!=='id'){
      local='en' 
    }
    this.$i18n.locale=local
    this.setLocal({local:local})
    let url =location.href
    if(url.includes('.html')){
      let str=url.replace('.html', '').split('/')
       this.tokencode=str[str.length-1]
       this.quoteAsset=str[str.length-2]
       this.setTokenCode({TokenCode:this.tokencode})
       this.setQuoteasset({quoteAsset:this.quoteAsset})
       this.setTradeActive({tradeActive:this.quoteAsset}) 
       this.bitLogin()
    }else{
      
      this.bitLogin()
    }
    
  },
  methods: {
    ...mapActions(['setExcnInfo','setZorro','setScore','setTickerDay','setWsTicker','setTradeList','setCountry','setBaseAsset','setQuoteasset','setTrade','setTradeActive','setLocal','setTheme','setTokenCode','setQp']),
    getZorro(country){
      let params={}
      bitCode(params,country).then(res=>{
        this.setZorro({zorroJson:res})
        this.getExInfo(country)
      })
    },
    // 登录天眼评分获取token
    bitLogin(){
        bitLogin().then(res=>{
          localStorage.setItem('TOKEN',res.access_token)
          this.deteIp()
      })
    },
    deteIp(){
      deteIp().then(res => {
        console.log(res);
        console.log('++++++++',res.result.province);
        if(res.succeed){
          let info = res.result
          console.log('国家',this.country);
          if(info.country==='中国'&&info.province!=='香港'&&info.province!=='澳门'&&info.province!=='台湾'){
            this.setCountry({country:true})
            this.getZorro(this.country)
            this.initWs(this.country)
            this.subscribe()
          }else{
            this.setCountry({country:false})
            this.getZorro(this.country)
            this.initWs(this.country)
            this.subscribe()
          }
          
        }
        
      })
    },
    getStar (kbscore) {
    if (!kbscore) return 0
    const sta = Number(kbscore).toFixed(2)
    if (sta < 1) return 0
    else if (sta > 1 && sta <= 1.25) return 1
    else if (sta >= 1.26 && sta <= 1.75) return 1.5
    else if (sta >= 1.76 && sta <= 2.25) return 2
    else if (sta >= 2.26 && sta <= 2.75) return 2.5
    else if (sta >= 2.76 && sta <= 3.25) return 3
    else if (sta >= 3.26 && sta <= 3.75) return 3.5
    else if (sta >= 3.76 && sta <= 4.25) return 4
    else if (sta >= 4.26 && sta <= 4.75) return 4.5
    else if (sta >= 4.76 && sta <= 5) return 5
  },
    // 获取评分
    bitScore(country){
      if(this.tokencode){
        let baseAsset=this.getBaseAssetByTokenCode[0].baseAsset
        bitScore(this.tokencode,country).then(res=>{
        let   {Data} = res
        this.setBaseAsset({baseAsset:baseAsset})
        this.setTrade({trade:baseAsset})
        let symbol=this.trade.replace('/','')
        let tradeInfo= this.symbolList .filter((item) => {
        return item.symbol===symbol
        })[0]
        console.log(tradeInfo.tickSize);
        this.setQp({tickSize:tradeInfo.tickSize,stepSize:tradeInfo.stepSize})
        // this.score=this.getStar(Data.result.kbscore)
          this.setScore({score:this.getStar(Data.result.kbscore)})
          // score 天眼评分
          // kbscore 口碑评级
        })
      }else{
        let tradeInfo= this.symbolList .filter((item) => {
        return item.symbol==='BTCUSDT'
        })[0]
        this.setTrade({trade:'BTC'})
        console.log(tradeInfo.tickSize);
        this.setQp({tickSize:tradeInfo.tickSize,stepSize:tradeInfo.stepSize})
        let evaluationCode=this.getTokenCode+''
          bitScore(evaluationCode,country).then(res=>{
          let   {Data} = res
          // this.score=this.getStar(Data.result.kbscore)
          this.setScore({score:this.getStar(Data.result.kbscore)})
          })
      }
    },
    // 获取24H价格变动情况
    getTickerDay(country){
      let params={}
      tickerDay(params,country).then(res=>{
        this.setTickerDay({tickerDay:res})
      })
    }, 
    // 获取近期成交
    getTrade(data,country){
      // let symbol='BTCUSDT'
      let params={
        symbol:data||'BTCUSDT',
        limit:60
      }
      recentTrade(params,country).then(res=>{
        // console.log(res);
        let data= res.map(item=>{
          let temp = {
              t: item.id,
              T: item.time,
              p: item.price,
              q: item.qty,
              isb:item.isBuyerMaker
            };
            // console.log(temp);
            return temp;
          })
          this.setTradeList({tradeList:data})
      })
    },
    // 获取交易规则和交易对
    getExInfo(country){
      let params={}
      exInfo(params,country).then(res=>{
        this.setExcnInfo({excnInfo:res})
        this.getTickerDay(country)
        this.bitScore(country)
      })
    }, 
    changeSwitch(){
      this.checked=!this.checked
    },  
    handleChange(){
    },
    initWs(country){
      this.socket= new socket(country)
      this.socket.doOpen();
      this.socket.onClose=this.websocketOnclose;
      this.socket.onError=this.websocketOnerror;
      this.socket.onMessage = this.websocketOnmessage;
    },
    async websocketOnmessage(e){
      await this.setWsTicker({wsTickerList:e.data})

    },
    subscribe() {
      let params = {
        id:1,
        method: "SUBSCRIBE",
        params:[ `!miniTicker@arr`]
        // value: `market.${this.symbol}.kline.${resolutionstr}`
      }
      this.sendMessage(JSON.stringify(params));
    },
    unSubscribe() {
      // 停止订阅，删除过期缓存、缓存时间、缓存状态

      let params = {
        id:1,
        method: "UNSUBSCRIBE",
        params:[ `!miniTicker@arr`]
      }
      this.sendMessage(JSON.stringify(params));
    },
    sendMessage(data){
    if (this.socket.checkOpen()) { //检验websocket是否打开
      this.socket.send(data);
    } else {
      this.socket.on('open', () => {
        this.socket.send(data);
      });
    }

    },
    websocketOnerror(e) {
      console.log("WebSocket连接发生错误");
      this.reconnect();
    },
    websocketOnclose(e) {
      console.log("connection closed (" + e.code + ")");
      this.reconnect();
    },
    reconnect() {
      var that = this;
      if(that.lockReconnect) return;
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
      console.info("尝试重连...");
      that.socket.destroy()
      that.initWs(that.country);
      that.subscribe()
      that.lockReconnect = false;
      }, 5000);
    },
  },
  destroyed() {
    this.unSubscribe()
  this.socket.destroy();
  },

}
</script>

<style lang="less">
.Market{
  height: 100%;
  // background-color: #262f3e;
  background-color: var(--grey700);
  // user-select: none;
  .market_marketContent{
    display: flex;
    height: calc(100% - 56px);
    padding-top: 6px;
    .market_leftbar{
      width: 300px;
      padding: 0 6px 0 0;
      height: 100%;
      overflow: hidden;
    }
    .market_middlebar{
      background-color: #0E1D2C;
      position: relative;
      flex: 1 1;
      overflow: hidden;
      .market_chartWrapper{
        display: flex;
        position: relative;
        height: calc(100% - 101px);
        .loading{
          // flex: ;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
    .market_rightbar{
      width: 28% !important;
      height: 100%;
      overflow-y: hidden;
      
    }
  }
  
}
</style>